import { useRef, useEffect, useState } from "react";
import styled, {  ThemeProvider } from "styled-components";
import { darkTheme } from "./Themes";
import LogoComponent from "./subComponents/LogoComponent";
import SocialIcons from "./subComponents/SocialIcons";
import PowerButton from "./subComponents/PowerButton";
import ParticleComponent from "./subComponents/ParticleComponent";
// import astronaut from "../assets/Images/mahesh.png";
import BigTitle from "./subComponents/BigTitle";
import { motion } from "framer-motion";
import Typed from "react-typed"
import 'react-vertical-timeline-component/style.min.css';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { FaGraduationCap, FaUserTie } from "react-icons/fa";
import {CenterMahi} from "./subComponents/AllSvgs";


const Box = styled.div`
  background-color: ${(props) => props.theme.body};
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
`;

// const float = keyframes`
//   0%{transform: translateY(-10px)}
//   50%{transform: translateY(15px) translateX(15px)}
//   100%{transform: translateY(-10px)}
// `;

// const Spaceman = styled.div`
//   position: absolute;
//   top: 10%;
//   right: 5%;
//   width: 20vw;
//   animation: ${float} 4s ease infinite;
//   img {
//     width: 100%;
//     height: auto;
//   }
// `;

const Main = styled.div`
  // border: 2px solid ${(props) => props.theme.text};
  color: ${(props) => props.theme.text};
  padding: 2rem;
  // width: 50vw;
  // height: 60vh;
  z-index: 3;
  line-height: 1.5;

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(0.6rem + 1vw);
  backdrop-filter: blur(4px);

  // position: relative;
  // left: calc(5rem + 5vw);
  // top: 0;

  font-family: "Ubutntu Mono", monospace;
  font-style: italic;
`;

const ImageContainer = styled.div`
  // position: relative;
  // top: 0%;
  // right: 5%;
  // width: 20vw;
  // height:60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  img {
    width: 100%;
    height: 100%;
  }
  // border: 2px solid ${(props) => props.theme.text};
`;

const RoundContainer = styled.div`
  display: flex;
  border-radius: 50%;
  border: 2px solid white;
  width: 90%;
  justify-content: center;
  text-align: center;
  box-shadow: 0 0 60px 30px #fff, /* inner white */ 0 0 100px 60px cadetblue/* outer cyan */
`;

const MainContainer = styled(motion.div)`
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  margin-top: 5%;
  @media (max-width: 700px) {
    display: block;
    margin-top: 5%;
  }
  width: 90%;
  margin-left: 5%;
`;

const Academics = styled.div`
  width:85%;
  // border:5px solid red;
  top:10%;
  position:relative;
  left:8%;
`;

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.8,
      duration: 1,
    },
  },
};

const Heading = styled.div`
  width:100%;
  text-align:center;
  h1{
    margin-bottom:5%;
    color:#fff;
  }
`;

// const TimeLine = styled.div`
// width:100%;
// position:relative;
// top: 11%;
// left: 5%;
// // border: 1px solid #fff;
// margin-top:10%;
// @media (max-width: 700px) {
//   display: block;
//   top: 10%;
// }
// width: 90%;
// `;

const TimeLine = styled.div`
  width: 100%;
  position: relative;
  margin-top: 10%;
  .vertical-timeline-element-date {
    color: #fff;
  }
  @media (max-width: 1160px) {
    .vertical-timeline-element-date {
      color: #000;
    }
  }
  @media (max-width: 700px) {
    display: block;
    .vertical-timeline-element-date {
      color: #000;
    }
  }
  width: 90%;
  margin-left: 5%;
  .vertical-timeline {
    margin-bottom: 5%;
  }
`;

const Profile = styled.div`
  position:fixed;
  right:1rem;
  @media (max-width: 720px) {
    position: absolute;
}`;

const CareerGrowthCard = styled.div`
  padding: 20px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.6);
`;

const RoleContainer = styled.div`
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const RoleTitle = styled.h4`
  margin: 0;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
`;

const RoleDates = styled.p`
  margin: 5px 0 0 0;
  color: #b0b0b0;
  font-size: 12px;
`;

const CompanyName = styled.h3`
  margin-bottom: 15px;
  color: #fff;
  font-size: 16px;
`;

const GrowthTransition = styled.div`
  position: relative;
  height: 40px;
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const TransitionLine = styled.div`
  position: absolute;
  width: 2px;
  height: 100%;
  background: linear-gradient(to top, #fff, transparent);
  left: 50%;
  transform: translateX(-50%);
  animation: growUp 1s ease-out forwards;
  animation-delay: 0.3s;
  
  @keyframes growUp {
    from {
      height: 0;
      opacity: 0;
    }
    to {
      height: 100%;
      opacity: 1;
    }
  }
`;

const GrowthArrow = styled.div`
  position: relative;
  z-index: 1;
  color: #fff;
  font-size: 24px;
  animation: moveUp 1.2s ease-out infinite;
  
  @keyframes moveUp {
    0% {
      transform: translateY(8px);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: translateY(-8px);
      opacity: 0;
    }
  }
`;

const QuoteSection = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  @media (max-width: 700px) {
    height: auto;
    padding: 40px 20px;
  }
`;

const QuoteContainer = styled.div`
  position: relative;
  padding: 40px 50px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  backdrop-filter: blur(10px);
  max-width: 600px;
  text-align: center;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
  transition: all 0.3s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.4);
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0.05) 100%);
    box-shadow: 0 12px 48px 0 rgba(31, 38, 135, 0.25);
  }

  &::before {
    content: '"';
    position: absolute;
    top: 15px;
    left: 20px;
    font-size: 48px;
    color: rgba(255, 255, 255, 0.3);
    font-weight: bold;
  }

  &::after {
    content: '"';
    position: absolute;
    bottom: 15px;
    right: 20px;
    font-size: 48px;
    color: rgba(255, 255, 255, 0.3);
    font-weight: bold;
  }

  @media (max-width: 700px) {
    padding: 30px 30px;
    &::before {
      font-size: 36px;
      left: 10px;
      top: 10px;
    }
    &::after {
      font-size: 36px;
      right: 10px;
      bottom: 10px;
    }
  }
`;

const QuoteText = styled.p`
  color: #fff;
  font-size: calc(1rem + 0.5vw);
  font-weight: 500;
  line-height: 1.8;
  margin: 0;
  font-style: italic;
  font-family: "Georgia", serif;
  letter-spacing: 0.5px;

  @media (max-width: 700px) {
    font-size: 1rem;
  }
`;

const QuoteAuthor = styled.p`
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
  margin-top: 20px;
  font-weight: 400;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: "Ubutntu Mono", monospace;

  &::before {
    content: '— ';
  }
`;


function AboutPage() {
  const typedRef = useRef(null);
  const [isTyping, setIsTyping] = useState(true);
  const boxRef = useRef(null);
  const typingStartedRef = useRef(false);
  const lastScrollTimeRef = useRef(Date.now());
  const isAutoScrollingRef = useRef(false);

  useEffect(() => {
    // Wait 5 seconds, then start scrolling to typed text
    const initialTimer = setTimeout(() => {
      if (boxRef.current && typedRef.current) {
        isAutoScrollingRef.current = true;
        const targetPosition = typedRef.current.offsetTop;
        const startPosition = boxRef.current.scrollTop;
        const distance = targetPosition - startPosition;
        const duration = 3000; // 3 seconds to scroll slowly
        const startTime = Date.now();

        const scroll = () => {
          const elapsed = Date.now() - startTime;
          const progress = Math.min(elapsed / duration, 1);
          
          // Easing function for smooth scrolling
          const easeProgress = progress < 0.5 
            ? 2 * progress * progress 
            : -1 + (4 - 2 * progress) * progress;
          
          boxRef.current.scrollTop = startPosition + distance * easeProgress;

          if (progress < 1) {
            requestAnimationFrame(scroll);
          } else {
            // Start typing when scroll finishes
            if (!typingStartedRef.current) {
              typingStartedRef.current = true;
              setIsTyping(true);
            }
            isAutoScrollingRef.current = false;
          }
        };

        requestAnimationFrame(scroll);
      }
    }, 5000); // Wait 5 seconds

    return () => clearTimeout(initialTimer);
  }, []);

  useEffect(() => {
    // Detect manual scroll interruption
    const handleScroll = () => {
      lastScrollTimeRef.current = Date.now();
      
      // If user manually scrolls during auto-scroll, stop it
      if (isAutoScrollingRef.current) {
        isAutoScrollingRef.current = false;
      }
    };

    const scrollElement = boxRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
      return () => scrollElement.removeEventListener("scroll", handleScroll);
    }
  }, []);

  useEffect(() => {
    // When typing finishes, start auto-scroll down after a delay
    if (!isTyping && typingStartedRef.current && !isAutoScrollingRef.current) {
      const scrollTimer = setTimeout(() => {
        if (boxRef.current) {
          isAutoScrollingRef.current = true;
          const startPosition = boxRef.current.scrollTop;
          const targetPosition = startPosition + window.innerHeight * 0.8;
          const duration = 4000; // 4 seconds for slow scroll down
          const startTime = Date.now();

          const scrollDown = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            // Easing function
            const easeProgress = progress < 0.5 
              ? 2 * progress * progress 
              : -1 + (4 - 2 * progress) * progress;
            
            boxRef.current.scrollTop = startPosition + (targetPosition - startPosition) * easeProgress;

            if (progress < 1 && isAutoScrollingRef.current) {
              requestAnimationFrame(scrollDown);
            } else {
              isAutoScrollingRef.current = false;
            }
          };

          requestAnimationFrame(scrollDown);
        }
      }, 800);

      return () => clearTimeout(scrollTimer);
    }
  }, [isTyping]);

  return (
    <ThemeProvider theme={darkTheme}>
      <Box ref={boxRef}>
        <LogoComponent theme="dark" />
        <SocialIcons theme="dark" />
        <PowerButton />
        <Profile fill={darkTheme.text}>
        <CenterMahi  width={100} height={120} fill={darkTheme.text}/>
        </Profile>
        <ParticleComponent theme="dark" />
        <Academics>
          <QuoteSection>
            <QuoteContainer>
              <QuoteText>I believe everything is an Art when you put your consciousness in it.</QuoteText>
              <QuoteAuthor>Mahesh Gaikwad</QuoteAuthor>
            </QuoteContainer>
          </QuoteSection>
          <MainContainer
            ref={typedRef}
            className="row"
            variants={container}
            initial="hidden"
            animate="show"
            exit={{
              opacity: 0,
              transition: { duration: 0.5 },
            }}
          >
            
            <Main className="col col-lg-8 col-md-8  col-sm-12 ">
              
            <Typed
                    strings={["I'm a Full Stack Web Developer located in India. I love to create simple yet beautiful websites with great user experience. I have developed various projects using MERN stack and like trying new things and building great projects. I'm a tech enthusiast and love to explore various new tools and write technical articles on various topics.",
                   ]}
                    typeSpeed={10}  
                    backSpeed={500}
                    onComplete={() => setIsTyping(false)}
                    // loop
            />

              
            </Main>

            <ImageContainer className="col col-lg-4 col-md-4 col-sm-12 ">
              <RoundContainer>
                {/* <img src={astronaut} alt="spaceman" /> */}
              </RoundContainer>
            </ImageContainer>
          </MainContainer>

          <TimeLine>
            <Heading>
              <h1>Work Experience</h1>
            </Heading>
            <VerticalTimeline lineColor="#fff">
              <VerticalTimelineElement
                 className="vertical-timeline-element--education"
                 iconStyle={{ background: "#fff", color: "#000" }}
                 icon={<FaUserTie />}
                 date="July 2024 - Present"
                 dateClassName="colorWhite"
              >
                <div style={{ background: 'rgba(0, 0, 0, 0.8)', padding: '20px', borderRadius: '8px', color: '#fff' }}>
                  <CareerGrowthCard>
                    <CompanyName>Bajaj General Insurance Limited</CompanyName>
                    
                    <RoleContainer>
                      <RoleTitle>Senior Application Engineer</RoleTitle>
                      <RoleDates>July 2025 - Present</RoleDates>
                    </RoleContainer>
                    
                    <GrowthTransition>
                      <TransitionLine />
                      <GrowthArrow>↑</GrowthArrow>
                    </GrowthTransition>
                    
                    <RoleContainer>
                      <RoleTitle>Application Engineer</RoleTitle>
                      <RoleDates>July 2024 - June 2025</RoleDates>
                    </RoleContainer>
                  </CareerGrowthCard>
                </div>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                 className="vertical-timeline-element--education"
                 iconStyle={{ background: "#000", color: "#fff" }}
                 icon={<FaUserTie />}
                 date="June 2023 - May 2024"
                 dateClassName="colorWhite"
              >
                <div style={{ background: 'rgba(255, 255, 255, 0.95)', padding: '20px', borderRadius: '8px', color: '#000' }}>
                  <h3 style={{ color: '#000', marginTop: '0' }}>Shunyeka Pvt. Ltd. (AutobotAI)</h3>
                  <p style={{ color: '#000' }}>
                    <strong>Full Stack Developer Intern </strong><span style={{color:'#666',fontSize:'10pt'}}> </span> 
                  </p>
                </div>
              </VerticalTimelineElement>
              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                iconStyle={{ background: "#fff", color: "#000" }}
                icon={<FaUserTie />}
                date="2023(Jan-June)"
                dateClassName="colorWhite"
              >
                <div style={{ background: 'rgba(0, 0, 0, 0.8)', padding: '20px', borderRadius: '8px', color: '#fff' }}>
                  <h3 style={{ color: '#fff', marginTop: '0' }}>SortWind Pvt. Ltd.</h3>
                  <p style={{ color: '#fff' }}>
                    <strong>Full Stack Developer Intern </strong><span style={{color:'#b0b0b0',fontSize:'10pt'}}> 6 months</span> 
                  </p>
                </div>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                iconStyle={{ background: "#000", color: "#fff" }}
                icon={<FaUserTie />}
                date="2022 (June - Dec)"
                dateClassName="colorWhite"
              >
                <div style={{ background: 'rgba(255, 255, 255, 0.95)', padding: '20px', borderRadius: '8px', color: '#000' }}>
                  <h3 style={{ color: '#000', marginTop: '0' }}>CHASHW INTERNET (OPC) PVT. LTD.</h3>
                  <p style={{ color: '#000' }}>
                    <strong>Frontend Developer Intern </strong> <span style={{color: '#666'}}>6 months</span>
                  </p>
                </div>
              </VerticalTimelineElement>

            </VerticalTimeline>
          </TimeLine>         
          
          <TimeLine>
            <Heading>
              <h1>Academics</h1>
            </Heading>
            <VerticalTimeline lineColor="#fff">

              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                iconStyle={{ background: "#fff", color: "#000" }}
                icon={<FaGraduationCap />}
                date="2020-2024"
              >
                <div style={{ background: 'rgba(0, 0, 0, 0.8)', padding: '20px', borderRadius: '8px', color: '#fff' }}>
                  <h3 style={{ color: '#fff', marginTop: '0' }}>International Institute of Information Technology, Pune.</h3>
                  <h4 style={{ color: '#fff' }}>B.E Computer</h4>
                  <p style={{ color: '#fff' }}>CGPA<strong> 9.07</strong></p>
                </div>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                iconStyle={{ background: "#000", color: "#fff" }}
                icon={<FaGraduationCap />}
                date="2018-2020"
                dateClassName="colorWhite"
              >
                <div style={{ background: 'rgba(255, 255, 255, 0.95)', padding: '20px', borderRadius: '8px', color: '#000' }}>
                  <h3 style={{ color: '#000', marginTop: '0' }}>Loyola Junior College, Pashan</h3>
                  <p style={{ color: '#000' }}>
                    HSC <strong>86.16%</strong>
                  </p>
                </div>
              </VerticalTimelineElement>

              <VerticalTimelineElement
                className="vertical-timeline-element--education"
                iconStyle={{ background: "#fff", color: "#000" }}
                icon={<FaGraduationCap />}
                date="2018"
                dateClassName="colorWhite"
              >
                <div style={{ background: 'rgba(0, 0, 0, 0.8)', padding: '20px', borderRadius: '8px', color: '#fff' }}>
                  <h3 style={{ color: '#fff', marginTop: '0' }}>St. Josephs Boys High School, Khadki</h3>
                  <p style={{ color: '#fff' }}>
                    SSC <strong>93.00%</strong>
                  </p>
                </div>
              </VerticalTimelineElement>
            </VerticalTimeline>
          </TimeLine>
         
        </Academics>
        <BigTitle text="ABOUT" top="10%" left="5%" />
      </Box>
    </ThemeProvider>
  );
}

export default AboutPage;
